export default __webpack_public_path__ + "static/61932592-01-7dee534f4e36de5737f1e21c7be53a46.webp";